<template>
  <div class="business-setup-complete container text-center py-5">
    <b-spinner variant="primary" style="width:2rem;height:2rem;"></b-spinner>
    <h4 class="mt-4">Setting up your business...</h4>
    <p class="text-muted">Please wait while we complete your business setup. This may take a few moments.</p>
    <div v-if="error" class="text-danger mt-3">{{ error }}</div>
  </div>
</template>

<script>
import Pusher from "pusher-js";
import Echo from "laravel-echo";

export default {
  name: 'BusinessSetupComplete',
  data() {
    return {
      error: '',
      echoChannel: null,
      timeout: null,
      maxWait: 90, // seconds
    };
  },
  mounted() {
    this.listenForSetupComplete();
    this.startTimeout();
  },
  beforeDestroy() {
    this.cleanupListener();
    if (this.timeout) clearTimeout(this.timeout);
  },
  methods: {
    listenForSetupComplete() {
      // Use global Echo instance if available
      window.Pusher = Pusher;
      window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.VUE_APP_ECHO_KEY, // '295948766410685f3c58',
        cluster: 'us3',
        forceTLS: true,
      });
      const echo = this.$echo || window.Echo;
      if (!echo) {
        this.error = 'Real-time event system not available.';
        return;
      }
      this.echoChannel = echo.channel(`business-setup.${this.$route.query.eid}`)
        .listen('.BusinessSetupComplete', (data) => {
          this.cleanupListener();
          if (this.timeout) clearTimeout(this.timeout);
          if(
            this.$route.query.eid === data.eid &&
            String(this.$route.params.agency) === String(data.aid)
          ){
            localStorage.setItem('business_setup_complete', 'true');
            this.$store
                .dispatch('auth/autologin', {token:data.token_pw})
                .then(() => {
                  this.$router.push({ name: 'new-business.dashboard' });
                })
                .catch((e) => {
                  console.log(e)
                })
          }
        });

    },
    cleanupListener() {
      const userId = this.$route.query.user_id;
      const echo = this.$echo || window.Echo;
      if (echo && userId) {
        echo.leave(`business-setup.${userId}`);
      }
    },
    startTimeout() {
      this.timeout = setTimeout(() => {
        this.error = 'Business setup is taking longer than expected. Please contact support.';
        this.cleanupListener();
      }, this.maxWait * 1000);
    },
  },
};
</script>

<style scoped>
.business-setup-complete {
  min-height: 40vh;
}
</style>
